import React from 'react';

import cn from 'classnames';

import cls from './InventoryPhotosDropzone.module.css';
import { useInventoryPhotosDropzone } from './useInventoryPhotosDropzone';

interface InventoryPhotosDropzoneProps {
    error: string;
    isDisabled: boolean;
    onUpload: (files: File[]) => void;
}

export const InventoryPhotosDropzone = ({
    error,
    isDisabled,
    onUpload,
}: InventoryPhotosDropzoneProps) => {
    const {
        t,
        inputId,
        inputRef,
        isDragActive,
        isDragReject,
        openFileDialog,
        handleInputChange,
        handleDragEnter,
        handleDragOver,
        handleDragLeave,
        handleDrop,
    } = useInventoryPhotosDropzone(isDisabled, onUpload);

    return (
        <div className={cls.dropzoneWrapper}>
            <div className={cls.dropzone}>
                <button
                    type="button"
                    className={cn(cls.dropzoneArea, {
                        [cls.dropzoneAreaActive]: isDragActive && !isDragReject,
                        [cls.dropzoneAreaReject]: isDragActive && isDragReject,
                        [cls.dropzoneAreaError]: Boolean(error),
                    })}
                    onClick={openFileDialog}
                    onDragEnter={handleDragEnter}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    disabled={isDisabled}
                    data-id="upload-inventory-images-wrapper"
                >
                    <div className={cls.uploadImage}>
                        <span className={cls.uploadImageText}>
                            {isDisabled && t('Dropzone.return.uploadImageText.isDisabled')}
                            {!isDisabled &&
                                isDragReject &&
                                t('imagePlaceholder.onInputChange.errors.invalid_format')}
                            {!isDisabled &&
                                isDragActive &&
                                !isDragReject &&
                                t('Dropzone.return.uploadImageText.isDragAccept')}
                            {!isDisabled &&
                                !isDragActive &&
                                !isDragReject &&
                                t('Dropzone.return.uploadImageText.isDragActive')}
                        </span>
                    </div>
                </button>
                <input
                    ref={inputRef}
                    id={inputId}
                    className={cls.dropzoneInput}
                    type="file"
                    accept="image/png, image/jpg, image/jpeg, image/gif"
                    multiple
                    onChange={handleInputChange}
                    data-id="upload-inventory-images"
                />
                <div className={cls.dropzoneMessage}>{error}</div>
            </div>
        </div>
    );
};
